import { RowCrudStatus } from "../../common/types";
import { SimulationSession } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { graphqlToDateTime } from "../../../common/utils";

export type SimulationSessionValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type SimulationSessionErrorsType = {};

export function SimulationSessionValuesInit(): SimulationSessionValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type SimulationSessionType =
  | SimulationSession
  | SimulationSessionValuesType;

export function simulationSessionDisplayId(
  source: Partial<SimulationSession>,
  _langStore: LangStore
) {
  return (
    (source.entryPipeline ?? _langStore.emptyStringSymbol) +
    "-" +
    `${graphqlToDateTime(source.startedAt)}`
  );
}

export function getSimulationSessionValues(
  source: SimulationSessionType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SimulationSessionValuesType {
  const entityValues = SimulationSessionValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : simulationSessionDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
